var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoutIcon = function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.553%",
    y1: "-54.318%",
    x2: "82.42%",
    y2: "147.336%",
    id: "logout-icon_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.142 6.659c.52.388.781 1.025.68 1.66a1.754 1.754 0 0 1-1.163 1.376c-6.638 2.716-11.21 8.812-11.885 15.85-.675 7.037 2.656 13.866 8.66 17.754a19.722 19.722 0 0 0 20.01.812 1.8 1.8 0 0 1 1.92-.147c.614.326.977.974.928 1.658a1.75 1.75 0 0 1-1.154 1.515A23.273 23.273 0 0 1 22.975 50C11.982 49.992 2.533 42.334.428 31.726-1.678 21.12 4.15 10.53 14.333 6.46a1.8 1.8 0 0 1 1.81.2Zm15.498-.2c6.99 2.78 12.147 8.755 13.8 15.988 1.654 7.232-.407 14.802-5.514 20.256-.343.366-.83.57-1.337.558a1.829 1.829 0 0 1-1.184-.454 1.729 1.729 0 0 1-.107-2.467c4.315-4.61 6.058-11.006 4.664-17.12-1.393-6.112-5.745-11.166-11.648-13.525a1.754 1.754 0 0 1-1.163-1.376c-.101-.635.16-1.272.68-1.66a1.8 1.8 0 0 1 1.809-.2ZM22.975 0c.98 0 1.775.782 1.775 1.746V23.51c0 .463-.187.907-.52 1.235a1.791 1.791 0 0 1-1.255.511c-.981 0-1.776-.782-1.776-1.746V1.746c0-.964.795-1.746 1.776-1.746Z",
    fill: "url(#logout-icon_svg__a)",
    fillRule: "evenodd"
  })));
};
export default SvgLogoutIcon;